import React from 'react';
import initialMetricsPublisher from '../../metrics';

class AmazonPayButton extends React.Component<{buttonConfig: any, payRegion: string, style: any }> {

    constructor(props: { buttonConfig: any; payRegion: string; style: any } | Readonly<{ buttonConfig: any; payRegion: string; style: any }>) {
        super(props);
        this.scriptLoaded = this.scriptLoaded.bind(this);
    }

    componentDidMount() {
        
        const amazonPayScript = document.createElement("script");
        amazonPayScript.async = true;
        amazonPayScript.src = `https://static-${this.props.payRegion}.payments-amazon.com/checkout.js`;
        amazonPayScript.onload = () => this.scriptLoaded();
        document.body.appendChild(amazonPayScript);
           
    }
    
    scriptLoaded = () => {
        const payButtonScript = document.createElement("script");
        const payButtonScriptText = `try { var amazonPayButton = amazon.Pay.renderButton('#AmazonPayButton', ${JSON.stringify(this.props.buttonConfig, null, " ")}); } catch(err) { document.getElementById("AmazonPayButton").innerHTML = "<pre>" + err + "</pre>";}`;

        payButtonScript.appendChild(document.createTextNode(payButtonScriptText));
        document.body.appendChild(payButtonScript);

    }
    
    render() {
        const actionMetricsPublisher = initialMetricsPublisher.newChildActionPublisherForMethod("ButtonRenderPage");
        actionMetricsPublisher.publishCounterMonitor('visits', 1);

        return (
            <div id="AmazonPayButton" style={this.props.style}></div>
        )
    }

};

export default AmazonPayButton;
